import { ColumnSelectionItem } from '../components/templates/ColumnSelection';

export const replenishmentColumnSelectionItems: Array<ColumnSelectionItem> = [
  {
    title: 'Replenishment Config',
    value: [
      {
        field: 'id',
        title: 'ID',
        value: false
      },
      {
        field: 'clientContract',
        title: 'Client/Contract',
        value: true
      },
      {
        field: 'location',
        title: 'Location',
        value: true
      },
      {
        field: 'partTypeOrSkuName', 
        title: 'PartType/SkuName', 
        value: true
      },
      {
        field: 'min', 
        title: 'Min', 
        value: true
      },
      {
        field: 'max', 
        title: 'Max',   
        value: true
      },
      {
        field: 'includeChildNode', 
        title: 'IncludeChildNode',
        value: true
      },
      {
        field: 'averageFreightLeadTimeOneMonth', 
        title: 'Average Freight Lead Time One Month', 
        value: false
      },
      {
        field: 'averageFreightLeadTimeThreeMonth', 
        title: 'Average Freight Lead Time Three Month', 
        value: false
      },
      {
        field: 'averageUsageOneMonth', 
        title: 'Average Usage One Month', 
        value: false
      },
      {
        field: 'averageUsageThreeMonth', 
        title: 'Average Usage Three Month', 
        value: false
      },
      {
        field: 'state', 
        title: 'State', 
        value: true
      },
      {
        field: 'condition', 
        title: 'Condition', 
        value: false
      },
      {
        field: 'stockOnHand', 
        title: 'Stock On Hand', 
        value: true
      },
      {
        field: 'inTransit', 
        title: 'In Transit', 
        value: true
      },
      {
        field: 'servicesInTrain', 
        title: 'Services In Train', 
        value: true
      },
      {
        field: 'replenishmentQuantity', 
        title: 'Replenishment Qty', 
        value: true
      },
      {
        field: 'replenishmentRequired', 
        title: 'Replenishment Required', 
        value: true
      },
      {
        field: 'distributionCentreMap', 
        title: 'Distribution Centre Map', 
        value: false
      },
      {
        field: 'action', 
        title: 'Dispatch', 
        value: true
      },
    ]
  }
];